export const createStyles = (theme?: any) => {
  const palette = theme?.palette;
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      minWidth: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      minHeight: {
        xs: '640px',
        md: '738px',
      },
      maxHeight: {
        xs: '640px',
        md: 'calc(100vh - 64px)',
      },
      maxWidth: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.16)',
      boxSizing: 'border-box',
      outline: 'none',
      overflow: 'hidden',
    },
    header: {
      flexShrink: 0,
      px: '16px',
      pt: '16px',
      pb: '16px',
    },
    closeRow: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    closeButton: {
      my: '5px',
    },
    title: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: 1.33,
      color: palette?.text?.primary,
      wordBreak: 'break-word',
    },
    lastEdited: {
      mt: '8px',
      fontSize: '14px',
      lineHeight: 1.8,
      color: palette?.text?.secondary,
    },
    content: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      px: '16px',
      mb: '24px',
      '& img, & iframe, & video': {
        maxWidth: '100%',
      },
      '& [data-testid="root-element"]': {
        width: '100% !important',
        maxWidth: '100%',
      },
      '& ul[data-slate-node="element"] span[data-slate-string="true"]': {
        display: 'block',
        maxWidth: { xs: 'calc(100vw - 62px)', md: '100%' }, // 32px padding + ~30px for bullet point
        wordBreak: 'break-word',
      },
      '& [class*="focusOutline"]': {
        pt: '0',
        // To remove dark border at the top of the editor when focused
        outline: 'none',
        '&:focus-within, &:focus-visible': {
          outline: 'none',
          boxShadow: 'none',
          borderColor: 'transparent',
        },
        // Apply the theme font only to normal text spans, leaving latex
        // (katex) and code block spans with their own fonts untouched.
        'span:not([data-testid="latex-syntax"] span):not([data-testid="code-block"] span):not(.katex):not(.katex span)':
          {
            fontFamily: theme?.typography?.fontFamily,
          },
      },
      // To remove dark border at the top of the editor when focused
      '& [data-testid="spacer"]': {
        background: 'none',
      },
      '& [data-testid="block-link-youtube"]': {
        width: { xs: '100% !important', md: '376px !important' },
      },
      '& div:has(> .katex-display)': {
        maxWidth: 'calc(100% - 140px)',
        overflow: 'auto',
      },
      '& .katex-display > .katex': {
        whiteSpace: 'normal',
        textAlign: 'start',
      },
      '& .katex .base': {
        whiteSpace: 'normal',
        width: 'auto',
        maxWidth: '100%',
        display: 'inline',
      },
      '& [data-testid="latex-syntax"], & .katex-syntax': {
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        textAlign: 'start',
      },
      '& [data-testid="code-block"] pre span[data-slate-string="true"]': {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      },
    },
    contentSkeleton: {
      mt: '24px',
    },
    description: {
      fontSize: '16px',
      lineHeight: 1.6,
      color: palette?.text?.primary,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
    footer: {
      flexShrink: 0,
      px: '16px',
      pb: '16px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    goToPageButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      width: '166px',
      height: '48px',
      '&:hover': {
        border: '1px solid !important',
      },
    },
  };
};
